function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { MedicalRecordContext } from 'context';
import App from 'modules/App';
import * as selectors from 'modules/PatientResults/selectors';
import { getHeightStyle } from '../helpers';
import styles from '../GlucoseConcentrationLevels.pcss';
import { getAggregateHeightStyle, getAggregatedGCL } from './helpers';
import AggregateValue from './AggregateValue';
import Goal from './Goal';
import LinkEndLine from './LinkEndLine';
import LinkStartLine from './LinkStartLine';
const Ranges = ({ glucoseConcentrationLevels, isNotingActive, onAddLevelNote })=>{
    const medicalRecord = useContext(MedicalRecordContext);
    const showTightRange = useSelector(selectors.showTightRange);
    const { dataType } = medicalRecord;
    const aggregatedGCL = getAggregatedGCL(glucoseConcentrationLevels, dataType);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.rangesContainer),
                children: glucoseConcentrationLevels.map((gcl, idx)=>/*#__PURE__*/ _jsxs("a", {
                        href: "",
                        className: cn(styles.segment, styles.segment_range, {
                            activeNoting: isNotingActive
                        }),
                        style: getHeightStyle(gcl),
                        onClick: (evt)=>onAddLevelNote(evt, gcl),
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mr-2",
                                children: [
                                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.levels[gcl.name])),
                                    (dataType === 'BGM' || gcl.name !== 'target' || showTightRange) && /*#__PURE__*/ _jsx("span", {
                                        className: "text--base text--bold ml-2",
                                        children: `${gcl.percentage}%`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(LinkStartLine, {
                                gcl: gcl,
                                idx: idx,
                                glucoseConcentrationLevels: glucoseConcentrationLevels,
                                aggregatedGCL: aggregatedGCL
                            })
                        ]
                    }, `barResult-${gcl.name}`))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.rangesContainer, 'm-0 align-items-start justify-content-between'),
                children: aggregatedGCL.map((aGCL)=>{
                    // Alternates to prevent calculation rounding and pixel shift
                    if (!aGCL.rOffset) {
                        return /*#__PURE__*/ _jsxs("div", {
                            className: cn(styles.segment, styles.segment_range),
                            style: getHeightStyle(aGCL),
                            children: [
                                /*#__PURE__*/ _jsx(LinkEndLine, {}),
                                /*#__PURE__*/ _jsx(AggregateValue, {
                                    aGCL: aGCL
                                }),
                                /*#__PURE__*/ _jsx(Goal, {
                                    aGCL: aGCL
                                })
                            ]
                        }, `aggregate-${aGCL.name}`);
                    }
                    return /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.segment, styles.segment_range, styles.segment_aggregate),
                        style: getHeightStyle(aGCL),
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: styles.aggregateWrapper,
                            style: getAggregateHeightStyle(aGCL),
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.aggregate,
                                    children: [
                                        /*#__PURE__*/ _jsx(LinkEndLine, {}),
                                        /*#__PURE__*/ _jsx(AggregateValue, {
                                            aGCL: aGCL
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Goal, {
                                    aGCL: aGCL
                                })
                            ]
                        })
                    }, `aggregate-${aGCL.name}`);
                })
            })
        ]
    });
};
export default Ranges;
